import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppLayout } from '../components/templates/AppLayout/AppLayout';
import { Header } from '../components/layout/Header';
import { Sidebar } from '../components/Sidebar';
import { AquariumForm } from '../components/AquariumForm';
import { createAquarium } from '../services/aquariumService';
import type { AquariumFormData } from '../types/aquarium';
import { PageContent } from '../components/templates/PageContent/PageContent';
import { PageHeader } from '../components/templates/PageHeader/PageHeader';
import { useTranslation } from '../i18n/useTranslation';

export function CreateAquariumPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  // Raw failure; AquariumForm maps it to a translated message (never the backend text).
  const [error, setError] = useState<unknown>(null);

  async function handleSubmit(data: AquariumFormData): Promise<void> {
    setIsLoading(true);
    setError(null);
    try {
      await createAquarium(data);
      navigate('/aquariums', { replace: true });
    } catch (err) {
      setError(err ?? new Error('create failed'));
      setIsLoading(false);
    }
  }

  function handleClose(): void {
    navigate('/aquariums');
  }

  return (
    <AppLayout
      header={<Header />}
      sidebar={<Sidebar />}
      main={
        <PageContent width="narrow">
          <PageHeader
            title={t('aquarium.form.create.title')}
            description={t('aquarium.emptyDescription')}
          />
          {/* AquariumForm renders as a full-screen overlay when isOpen=true */}
          <AquariumForm
            isOpen={true}
            onClose={handleClose}
            onSubmit={handleSubmit}
            isLoading={isLoading}
            error={error}
          />
        </PageContent>
      }
    />
  );
}

export default CreateAquariumPage;
